import { FC } from 'react';
import { useIntl } from 'react-intl';

import { useFelaEnhanced } from 'hooks';

import * as felaRules from './ServiceLineCard.rules';
import { QaSource } from '../../types';

interface ServiceLineCardProps {
    source: QaSource;
}

const ServiceLineCard: FC<ServiceLineCardProps> = ({ source }) => {
    const { styles } = useFelaEnhanced(felaRules);
    const intl = useIntl();

    return (
        <div className={styles.container}>
            <div className={styles.serviceName}>{source.service_name}</div>
            <div className={styles.metaRow}>
                <div className={styles.metaItem}>
                    <span className={styles.metaLabel}>
                        {intl.formatMessage({ id: 'assistant.evidence.quoteDate' })}
                    </span>
                    {source.quote_date ? (
                        <span className={styles.metaValue}>{source.quote_date}</span>
                    ) : (
                        <span className={styles.metaValueMuted}>
                            {intl.formatMessage({ id: 'assistant.evidence.unknown' })}
                        </span>
                    )}
                </div>
                <div className={styles.metaItem}>
                    <span className={styles.metaLabel}>
                        {intl.formatMessage({ id: 'assistant.evidence.salesforceId' })}
                    </span>
                    {source.salesforce_line_item_id ? (
                        <span className={styles.metaValue}>{source.salesforce_line_item_id}</span>
                    ) : (
                        <span className={styles.metaValueMuted}>
                            {intl.formatMessage({ id: 'assistant.evidence.unknown' })}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ServiceLineCard;
